import React from 'react'

import { corDash as cor } from '../../../utils/dashboard.js'
import { formatarMilharSemDecimais } from '../../../utils/formatarMilhar'

import CardHeader from './CardHeader'
import MyPieChart from './MyPieChart'
import TooltipGraficoPizza from './TooltipGraficoPizza'

export default function GraficoSimcardsStatus({
  portalCliente,
  handleAbrirMenuOpcoes,
  revelarOpcoesSimcardsStatus,
  menuElement,
  arraySimcardsStatus,
  tooltipSimcardsStatus,
  tooltipSimcardsOnline,
  tooltipSimcardsOffline,
  tooltipSimcardsEmEstoque,
  totalSimcards
}) {
  return (
    <div
      className="container-dashboard-fundo-1  fundo-cor-5"
      id="grafico-simcards-status"
    >
      <CardHeader
        id="1"
        key="1"
        titulo="SIM cards Status"
        nomeOpcao="simcardsStatus"
        portalCliente={portalCliente}
        handleAbrirMenuOpcoes={handleAbrirMenuOpcoes}
      />
      <div className="grupo-dash-grafico-pizza-grande">
        {revelarOpcoesSimcardsStatus === true && (
          <div className="menu-opcoes-dashboard-fundo">{menuElement}</div>
        )}
        <div className="container-dash-grafico-pizza-grande">
          <MyPieChart
            key={JSON.stringify(arraySimcardsStatus)}
            data={arraySimcardsStatus}
            valorPercentual={tooltipSimcardsStatus}
            MyTooltip={(rechartsProps) => (
              <TooltipGraficoPizza
                {...rechartsProps}
                arrDados={arraySimcardsStatus}
                totalSimcards={totalSimcards}
              />
            )}
          />
        </div>
        <div className="container-legenda-status">
          <div className="linha-legenda-status">
            <div className="coluna-legenda-status-1">
              <div
                className="esfera-legenda-dashboard"
                style={{ backgroundColor: cor.verdeClaro }}
              />
            </div>
            <div className="coluna-legenda-status-2">
              <span className="fonte-cor-1 texto-legenda-sem-comunicar">
                Online
              </span>
            </div>
            <div className="coluna-legenda-status-3">
              <span className="fonte-cor-1 texto-legenda-box-status">
                {formatarMilharSemDecimais(tooltipSimcardsOnline)}
              </span>
            </div>
          </div>
          <div className="linha-legenda-status">
            <div className="coluna-legenda-status-1">
              <div
                className="esfera-legenda-dashboard"
                style={{ backgroundColor: cor.vermelho }}
              />
            </div>
            <div className="coluna-legenda-status-2">
              <span className="fonte-cor-1 texto-legenda-sem-comunicar">
                Offline
              </span>
            </div>
            <div className="coluna-legenda-status-3">
              <span className="fonte-cor-1 texto-legenda-box-status">
                {formatarMilharSemDecimais(tooltipSimcardsOffline)}
              </span>
            </div>
          </div>
          <div className="linha-legenda-status">
            <div className="coluna-legenda-status-1">
              <div
                className="esfera-legenda-dashboard"
                style={{ backgroundColor: cor.azul }}
              />
            </div>
            <div className="coluna-legenda-status-2">
              <span className="fonte-cor-1 texto-legenda-sem-comunicar">
                Estoque
              </span>
            </div>
            <div className="coluna-legenda-status-3">
              <span className="fonte-cor-1 texto-legenda-box-status">
                {formatarMilharSemDecimais(tooltipSimcardsEmEstoque)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
